import Modal from 'LuxKit/Modal/Modal'
import TourV2FinePrint from 'components/OfferPage/TourV2/FinePrint/TourV2FinePrint'
import React, { ComponentProps, memo } from 'react'

type InheritedModalProps = Pick<ComponentProps<typeof Modal>, 'subtitle'>

interface Props extends InheritedModalProps {
  finePrint: App.Tours.TourV2OfferFinePrint
}

function TourV2FinePrintModal(props: Props) {
  const { finePrint, subtitle } = props

  return <Modal title="Trip Fine Print" subtitle={subtitle}>
    <TourV2FinePrint finePrint={finePrint} />
  </Modal>
}

export default memo(TourV2FinePrintModal)
